<!--
  입대업체 그룹목록 조회 화면입니다.
  신규 그룹 생성 및 수정, 삭제가 가능합니다.
 -->
<template>
  <main-layout>
    <template #header>
      <main-header :is-mobile="isMobile" :title="'임대업체 그룹' | translate" />

      <search-bar
          v-model="searchOptions.searchKeyword"
          :placeholder="'그룹명/임대업체' | translate"
          class="search-select"
      />
    </template>

    <template #toolbar>
      <main-toolbar>
        <!-- 사용여부 선택 필터 -->
        <div style="width: 150px">
          <search-single-select-box
              v-model="searchOptions.deleteYn"
              :items="deleteOptions"
              :label="'삭제여부' | translate"
              style="width: 150px;"
              @update:selected="onFilterChanged"
          />
        </div>
      </main-toolbar>
    </template>

    <template #feature>
    </template>

    <template #body>
      <main-body>
        <!-- 신규 그룹 정보 등록 버튼 -->
        <rental-company-group-add-button
            style="display: block"
            class="mb-2"
            :button-type="CODE.POPUP_TYPE.REGISTER"
            :rental-companies="rentalCompanies"
            @saved-complete="onSavedComplete"
        />

        <!-- 목록 테이블 -->
        <base-table :headers="headers" :is-loading="isLoading" :items="items" :items-total-count="itemsTotalCount"
                    :infinity-scroll="infinityScroll"
                    :sort-option="sortOption"
                    :page-number="searchOptions.pageNumber"
                    :page-length="pageLength"
                    @on-page-change="e => onLoad(e)"
                    @on-sort-change="onSortChange"
                    @on-click-item="item => onClickItem(item)"
        >
        </base-table>

        <!-- 그룹 정보 수정 팝업 -->
        <rental-company-group-popup
          :button-type="CODE.POPUP_TYPE.EDIT"
          :item.sync="selectedItem"
          :show.sync="showEditPopup"
          :rental-companies="rentalCompanies"
          @saved-complete="onSavedComplete"
        />
      </main-body>
    </template>
  </main-layout>
</template>

<script>
import MainLayout from "@/components/common/layout/MainLayout.vue";
import MainBody from "@/components/common/layout/MainBody.vue";
import MainHeader from "@/components/common/layout/MainHeader.vue";
import {PATH} from "@/constants";
import RentalCompanyGroupAddButton from "@/views/rental-company/manager/group/RentalCompanyGroupAddButton.vue";
import RentalCompanyGroupPopup from "@/views/rental-company/manager/group/RentalCompanyGroupPopup.vue";
import SearchBar from "@/components/input/SearchBar.vue";
import BaseTable from "@/components/common/newBase/InfinityScrollTable.vue";
import Headers from "@/components/common/newBase/Headers.vue";
import MainToolbar from "@/components/common/layout/MainToolbar.vue";
import SearchSingleSelectBox from "@/components/input/SingleSelectBox.vue";

export default {
  name: "RentalCompanyGroupList",
  components: {
    SearchSingleSelectBox,
    MainToolbar,
    RentalCompanyGroupAddButton,
    SearchBar,
    RentalCompanyGroupPopup,
    MainHeader,
    MainBody,
    MainLayout,
    BaseTable,
  },
  extends: Headers,

  data() {
    return {
      headers:[],
      searchOptions: {
        pageNumber: 1,
        pageSize: 30,
        searchKeyword: undefined,
        deleteYn: undefined,
      },
      isMobile: false,

      // 삭제 성공 메시지
      deleteSuccessText: this.$translate('그룹이 삭제되었습니다.'),
      // 삭제 실패 메시지
      deleteFailText: this.$translate('그룹 삭제가 실패했습니다.'),

      // 현대 선택된 행
      selectedItem: undefined,
      showEditPopup: false,

      // 전체 임대업체 목록
      rentalCompanies: [],


      sortOption: {
        sortBy: ['deleteYn'],
        sortDesc: ['false'],
      },
      infinityScroll: true,
      items: [],
      itemsTotalCount: undefined,
      isLoading: false,

      deleteOptions: [
        {codeValue: this.t('삭제'), codeKey: 'Y'},
        {codeValue: this.t('사용'), codeKey: 'N'},
      ]
    }
  },

  computed: {
    pageLength() {
      if(!this.itemsTotalCount) return 1
      return Math.ceil(this.itemsTotalCount / this.searchOptions.pageSize)
    }
  },

  watch: {
    'searchOptions.searchKeyword': {
      handler(newValue, oldValue) {
        this.onLoad(1)
      }
    },
  },

  created() {
    this.checkMobile();
    this.requestGetAllRentalCompanies();
  },

  beforeMount() {
    this.headers = this.rentalCompanyGroupHeaders
    this.initPage()
  },

  methods: {
    initPage() {
      this.searchOptions.pageNumber = 1;
      this.itemsTotalCount = undefined
      this.items = []
      this.loadData();
    },

    async loadData() {
      if (this.isLoading) return
      try {
        this.isLoading = true
        const res = await this.$request(PATH.RANTALCOMPANY_GROUP.LIST)
            .setObject(
                {...this.searchOptions, ...this.sortOption}
            )
            .catch()
            .enqueue()

        this.itemsTotalCount = res.dataTotalCount
        this.items.push(...res.data)
      } catch (e) {
        alert('Error')
      } finally {
        this.isLoading = false
      }
    },

    checkMobile() {
      this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      console.log('!!!!!!!!!!! t this.isMobile ', this.isMobile);
    },


    /**
     * 전체 임대업체 목록을 불러옵니다.
     */
    requestGetAllRentalCompanies(){
      // 모든 임대업체 목록을 조회합니다.
      this.$request(PATH.RANTALCOMPANY_GROUP.RENTALCOMPANY_ALL_LIST)
          .enqueue()
          .then((res)=>{
            this.rentalCompanies = res.data
          })
          .catch((err)=>{
            // alert(this.deleteFailText)
          })
    },

    /**
     * 저장 완료 이벤트 리스너
     * RentalCompanyGroupButton 에서 이벤트 발생
     */
    onSavedComplete(){
      this.selectedItem = undefined
      this.showEditPopup = false
      this.onLoad(1)
    },

    onSortChange(option) {
      Object.keys(option).forEach( e => {
        this.sortOption[e] = option[e]
      })
      this.onFilterChanged()
    },

    onFilterChanged(update){
      this.onLoad(1)
    },

    onLoad(pageNumber) {
      this.searchOptions.pageNumber = pageNumber
      if (!this.infinityScroll || pageNumber === 1)
        this.items.splice(0, this.items.length)
      this.loadData()
    },

    onClickItem(item) {
      this.selectedItem = item
      this.showEditPopup = true
    },
  },

}
</script>

<style scoped>
.memo-column{
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: inherit;
  width: 500px;
}
.search-select{
  width: 450px;
}
.default-row{
  cursor: pointer;
}
</style>
